import { RoutePermittedRole } from "shared/constants/AppConst";
import PageMapping from "./pageMapping";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";

export const pageMappingConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/planMaster/planPageMapping",
    exact: true,
    element: isModuleAuthorized("Plan-Page Mapping") ? <PageMapping /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/planMaster/planPageMapping/pageMapping",
    exact: true,
    element: isModuleAuthorized("Plan-Page Mapping") ? <PageMapping /> : <Error403 />,
  },
];
